module.exports = {
  'about': 'Pri la retejo',
  'for_helpers': 'Por helpantoj',
  'menu': 'Menuo',
  'history': 'Historio',
  'search_word': 'Serĉi la vorton...',
  'n_i_ashmarin': 'N.I. Aŝmarin',
  'chuvash_dictionary': 'Vortaro de la Ĉuvaŝa lingvo',
  'articles_on_site': 'Kuranta kvanto de vort-artkoloj',
  'last_added_articles': 'Laste aldonitaj vort-artikoloj',
  'haval_org': 'Ĉuvaŝa socia organizo "Ĥaval"',
  'more_text': 'Plu...'
}


// WEBPACK FOOTER //
// ./src/lang/eo/messages.js